import type { ReactNode } from 'react';

import { Badge } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { KHONG_CO } from '../../../../lib/dinh-dang';
import { MUC_DO_LOI, NGUON_SU_CO_HIEN, TINH_CHAT_LOI, TRANG_THAI_INSTANCE } from '../../constants';
import { loiNgan } from '../../nghiep-vu/su-co';
import type { LoaiLoi, MucDo, NguonSuCo } from '../../types';

/** Trạng thái instance/lượt chạy; giá trị OpenCore lạ hiện nguyên văn, tông xám. */
export function BadgeTrangThaiLuot({ status }: { status: string }) {
  const { t } = useT();
  const tt = TRANG_THAI_INSTANCE[status];
  return (
    <Badge variant={tt?.variant ?? 'neutral'} className="whitespace-nowrap">
      {tt ? t(tt.khoa) : status || KHONG_CO}
    </Badge>
  );
}

/** Mức độ lỗi — luôn kèm chữ, không chỉ dựa vào màu. */
export function BadgeMucDo({ mucDo }: { mucDo: MucDo }) {
  const { t } = useT();
  const m = MUC_DO_LOI[mucDo];
  return (
    <Badge variant={m.variant} className="whitespace-nowrap">
      {t(m.khoa)}
    </Badge>
  );
}

export function BadgeNguon({ nguon }: { nguon: NguonSuCo }) {
  const { t } = useT();
  const n = NGUON_SU_CO_HIEN[nguon];
  return (
    <Badge variant={n.variant} className="whitespace-nowrap">
      {t(n.khoa)}
    </Badge>
  );
}

/** Lường trước được (đã khai ở Cấu hình lỗi) hay bất ngờ. */
export function BadgeLoaiLoi({ loai }: { loai: LoaiLoi }) {
  const { t } = useT();
  const l = TINH_CHAT_LOI[loai === 'foreseen' ? 'luongTruoc' : 'batNgo'];
  return (
    <Badge variant={l.variant} className="whitespace-nowrap">
      {t(l.khoa)}
    </Badge>
  );
}

/** Lỗi thô → câu ngắn theo ngôn ngữ đang xem ("Quá thời gian chờ"…); không khớp mẫu thì câu lõi của lỗi. */
export function useLoiNgan(): (raw: string | null | undefined) => string {
  const { t } = useT();
  return (raw) => {
    const n = loiNgan(raw);
    if (!n) return raw ?? '';
    return 'ma' in n ? t(`rpaSuCo.loiNgan.${n.ma}`) : n.chu;
  };
}

/** Một cặp nhãn–giá trị trong `<dl>`; giá trị rỗng hiện `—`. */
export function TruongThongTin({ nhan, children }: { nhan: string; children: ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs text-content-muted">{nhan}</dt>
      <dd className="break-words text-sm text-content-primary">{children || KHONG_CO}</dd>
    </div>
  );
}
